export function parseDecimal(source) {
    return parseFloat(Number(source).toFixed(2));
}
export function getDaysDifference(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);

    const diffTime = end - start;
    return diffTime / (1000 * 60 * 60 * 24);
}
export function convertToUtcDateString(date) {
    if (date.toString().charAt(date.length - 1) !== 'z') {
        return date + 'z';
    }

    return date;
}
export function getDaySuffix(day) {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
}

export function appendSearchParams(url, params = {}) {
    if (!url) return url;

    const [baseUrl, hashFragment] = url.split('#');

    // If no hash routing → normal behavior
    if (!hashFragment) {
        const urlObj = new URL(
            url,
            typeof window !== 'undefined' ? window.location.origin : undefined
        );

        Object.entries(params).forEach(([key, value]) => {
            if (value == null) return;

            if (Array.isArray(value)) {
                value.forEach(v => urlObj.searchParams.append(key, v));
            } else {
                urlObj.searchParams.set(key, value);
            }
        });

        return urlObj.toString();
    }

    // Handle AngularJS hash routing
    const [hashPath, hashQueryString] = hashFragment.split('?');
    const searchParams = new URLSearchParams(hashQueryString || '');

    Object.entries(params).forEach(([key, value]) => {
        if (value == null) return;

        if (Array.isArray(value)) {
            value.forEach(v => searchParams.append(key, v));
        } else {
            searchParams.set(key, value);
        }
    });

    const newHash = `${hashPath}?${searchParams.toString()}`;

    return `${baseUrl}#${newHash}`;
}


export function appendUrlParts(baseUrl, pathSegments = [], queryParams = {}) {
    const url = new URL(
        baseUrl,
        typeof window !== 'undefined' ? window.location.origin : undefined
    );

    // Normalize path segments
    const segments = Array.isArray(pathSegments)
        ? pathSegments
        : [pathSegments];

    // Clean and append path
    const cleanSegments = segments
        .filter(Boolean)
        .map(segment => segment.replace(/^\/+|\/+$/g, ''));

    if (cleanSegments.length) {
        url.pathname = [
            url.pathname.replace(/\/+$/g, ''),
            ...cleanSegments
        ].join('/');
    }

    // Append query params
    Object.entries(queryParams).forEach(([key, value]) => {
        if (value == null) return;

        if (Array.isArray(value)) {
            value.forEach(v => url.searchParams.append(key, v));
        } else {
            url.searchParams.set(key, value);
        }
    });

    return url.toString();
}
export function convertToJuiceDate(date) {
    if (!date) return null;
    const d = new Date(date);
    return new Date(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}T${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}:${String(d.getSeconds()).padStart(2, '0')}.000Z`);
}